// ══════════════════════════════════════════════════════════════════════════════
// Aura Feedback Service
// ══════════════════════════════════════════════════════════════════════════════
// Persists couple feedback signals to aura_feedback.
// Called from WorkspaceCenter + AuraMiniBar after thumb interaction.
// Fire-and-forget: never blocks UI, never throws to caller.
// ══════════════════════════════════════════════════════════════════════════════

const SUPABASE_URL  = import.meta.env.VITE_SUPABASE_URL  as string;
const SUPABASE_ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export type FeedbackSignal    = 'helpful' | 'not_helpful';
export type FeedbackSubSignal = 'too_expensive' | 'wrong_style' | 'wrong_region' | 'not_relevant';

export interface AuraFeedbackPayload {
  session_id:    string;
  query_id:      string | null;
  listing_ids:   string[];
  signal:        FeedbackSignal;
  sub_signal?:   FeedbackSubSignal | null;
  anonymous_id?: string | null;
  turn_number?:  number | null;
  intent_region?: string | null;
  intent_styles?: string[];
}

export async function submitAuraFeedback(payload: AuraFeedbackPayload): Promise<void> {
  if (!SUPABASE_URL || !SUPABASE_ANON) return;

  try {
    await fetch(`${SUPABASE_URL}/rest/v1/aura_feedback`, {
      method:  'POST',
      headers: {
        'Content-Type':  'application/json',
        'apikey':        SUPABASE_ANON,
        'Authorization': `Bearer ${SUPABASE_ANON}`,
        'Prefer':        'return=minimal',
      },
      body: JSON.stringify({
        session_id:    payload.session_id,
        query_id:      payload.query_id     ?? null,
        listing_ids:   payload.listing_ids  ?? [],
        signal:        payload.signal,
        sub_signal:    payload.sub_signal   ?? null,
        anonymous_id:  payload.anonymous_id ?? null,
        turn_number:   payload.turn_number  ?? null,
        intent_region: payload.intent_region ?? null,
        intent_styles: payload.intent_styles ?? [],
      }),
    });
  } catch {
    // Silent, feedback loss is acceptable; never crash the UI
  }
}
